/**
 * Can be used in the default block of switch statements to make sure all cases have been handled
 * @param _
 */
export function exhaustiveCheck(_: never): never { // eslint-disable-line
  throw new Error("Exhaustive check has not passed")
}
